module.exports = __webpack_public_path__ + "img/anevil_front.980b2659.jpeg";